import { Box, useMediaQuery } from '@mui/material'
import { Showable, useStyles } from '@sweatpals/react-ui-kit';
import Link from 'next/link';
import Image from 'next/image';
import React from 'react'
import DesktopLeaderboardBanner from '@/public/assets/images/leaderboard-banners/desktop-banner.webp';
import MobileLeaderboardBanner from '@/public/assets/images/leaderboard-banners/mobile-banner.webp';
import { inviteBannerStyles } from './invite-banner.styles';

export const InviteBanner: React.FC = () => {
  const isLowerThan1200 = useMediaQuery('(max-width: 1200px)');
  const styles = useStyles(inviteBannerStyles);

  return (
    <Box sx={styles.wrapper}>
			<Link href="/globalrunningday">
        <Showable show={!isLowerThan1200}>
          <Image src={DesktopLeaderboardBanner} alt='desktop-leaderboard-banner' width={1166} height={292} />
        </Showable>
        <Showable show={isLowerThan1200}>
          <Image src={MobileLeaderboardBanner} alt='mobile-leaderboard-banner' width={370} height={212} />
        </Showable>
      </Link>
    </Box>
  )
}
